module.exports = __webpack_public_path__ + "static/media/iconlite.cd9d5d74.png";